import { makeObservable, observable } from 'mobx';
import { IStore } from './index';

export enum Severity {
  Information,
  Error,
}

export class ToastStore {
  constructor(private rootStore: IStore) {
    makeObservable(this);
  }

  @observable message: string | undefined;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  showMessage(message: string, severity: Severity) {
    this.message = message;
  }
}
